module.exports = __webpack_public_path__ + "img/StarFull.66ebab94.svg";